import {Modal} from '@mantine/core';

export const ModalTheme = Modal.extend({
  defaultProps: {
    lockScroll: false,
    centered: true,
  },
});